import { gql } from "@apollo/client";

export const GET_IMPRIMIR_MINUTA_CONEXIONES = gql`
    query GetConexionesMinuta($idMinuta: Int!) {
        conexionesMinuta(idMinuta: $idMinuta) {
            idConexion,
            fechaConexion
        }
    }
`;

export const adaptImprimirMinutasConexiones = (conexion) => {
  return {
    idConexion: conexion?.idConexion,
    fechaConexion: conexion?.fechaConexion
  };
};

export const adaptImprimirMinutasConexionesArray = (minutas) => {
  return structuredClone(minutas)?.
  map((minuta) => adaptImprimirMinutasConexiones(minuta));
};